module.exports = __webpack_public_path__ + "img/VN-sp.9f95aaaf.png";